export const formatIBAN = (iban) => {
  if (!iban) return 'N/A'
  const ibanWithoutSpace = iban.replace(/\s/g, '');
  const ibanFormatted = ibanWithoutSpace.replace(/(.{4})/g, '$1 ');
  return ibanFormatted.trim();
}